import { Box, Divider, Typography } from "@mui/material";
import { HelperButton, HelperContainer, HelperText } from "../../pages/Dashboard/styles";
import { IDivida } from "../../interfaces/Divida";
import { IBuscaOpcaoPagamento, IOpcaoPagamento } from "../../interfaces/BuscaOpcaoPagamento";
import DividaAcordoItem from "../DividaAcordoItem";
import React, { FC, useCallback, useEffect, useState } from "react";
import { IAcordo } from "../../interfaces/Acordo";
import { ParcelamentoRequestProps } from "../../pages/Dashboard/Dashboard";
import { useParams } from "react-router-dom";
import { useTracking } from "../../contexts/tracking";
import { IUser } from "../../interfaces/User";
import { AcaoEvento } from "services/TrackingService";
import DividaItem from "components/DividaItem/DividaItem";

type IHelperId = 'dividas_ativas' | 'acordos';

type DividaListaProps = {
  user: IUser | null | undefined
  opcao: IBuscaOpcaoPagamento;
  dividas: IDivida[];
  acordos: IAcordo[];
  onClickEnviarAcordo: ({ divida, opcaoPagamento }: any) => Promise<void>;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setInitialCateriaId: React.Dispatch<React.SetStateAction<number | null>>;
  setDividaSelecionada: React.Dispatch<React.SetStateAction<IDivida | null>>;
  setIsReorg: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenDebitoConta: React.Dispatch<React.SetStateAction<boolean>>;
  setOpcao: React.Dispatch<React.SetStateAction<IBuscaOpcaoPagamento>>;
  setDebitoContaProps: React.Dispatch<any>;
  setIsDialogError: React.Dispatch<React.SetStateAction<boolean>>;
  opcaoHandleChange: (newOption: any) => void;
  onSubmitParcelamento: (value: ParcelamentoRequestProps) => Promise<void>;
}

export const DividaLista: FC<DividaListaProps> = (props) => {
  const { trackId } = useParams<{ trackId: string | undefined }>()
  const { sendTracking } = useTracking();
  const { user, opcao, dividas, acordos, onClickEnviarAcordo, setOpen, setInitialCateriaId, setDividaSelecionada, setIsReorg, setOpenDebitoConta, setOpcao, setDebitoContaProps, setIsDialogError, opcaoHandleChange, onSubmitParcelamento } = props;

  const [helperId, setHelperId] = useState<IHelperId | null>(null);
  const [showHelper, setShowHelper] = useState(false);

  function onClickRegularizar(item: IDivida) {
    setOpen(true);
    setInitialCateriaId(item?.carteiraId as number);
  }

  useEffect(() => {
    sendTracking({ trackId, acao: AcaoEvento.Login, cpfCnpj: user?.cnpJ_CPF });
  }, []);

  return (
    <>
      {
        !!dividas.length &&
        (
          <Box display="flex" alignItems="flex-start">
            <Typography
              variant="h6"
              style={{ color: 'black', fontWeight: 'bold' }}
            >
              Dividas ativas
            </Typography>
            <HelperButton
              onMouseOver={() => {
                setHelperId('dividas_ativas');
                setShowHelper(true);
              }}
              onMouseOut={() => setShowHelper(false)}
            >
              <span>?</span>
            </HelperButton>
            {showHelper && helperId === 'dividas_ativas' && (
              <HelperContainer>
                <HelperText>Veja suas dívidas, opções de pagamento disponíveis e dia de vencimento para pagamento.</HelperText>
              </HelperContainer>
            )}
          </Box>
        )
      }

      {
        dividas?.map(
          (item, index) => {
            return (
              <DividaItem
                key={Number(item?.carteiraId) + index}
                item={item}
                itemIndex={index}
                onClickRegularizar={() => onClickRegularizar(item)}
                onClickParcelamento={
                  ({ item: parcelamento, opcao: novaOpcao }: { item: IDivida; opcao: IBuscaOpcaoPagamento; }) => {
                    setDividaSelecionada(parcelamento);
                    setOpcao(novaOpcao);
                  }
                }
                onClickFirmarAcordo={
                  ({ divida, primeiraParcela, DataValidade, novaOpcao }: { divida: IDivida; primeiraParcela: IOpcaoPagamento; DataValidade: Date; novaOpcao: IBuscaOpcaoPagamento; }) => {
                    if (primeiraParcela?.opcaoDebitoEmConta) {
                      setIsReorg(divida.tipoContrato === "REORGPF");
                      setOpenDebitoConta(true);
                      setDebitoContaProps({ parcelamento: primeiraParcela, DataValidade, dividaSelecionada: divida });
                      return;
                    }

                    if (novaOpcao?.opcoesPagamento && !(novaOpcao?.opcoesPagamento?.length > 0)) {
                      setIsDialogError(true);
                      onClickRegularizar(item);
                      return;
                    }
                    setOpcao(opcao);
                    onSubmitParcelamento({ divida, parcelamento: primeiraParcela, DataValidade, novaOpcao });
                  }
                }
                onClickEnviarAcordo={onClickEnviarAcordo}
                usaResumoApi={!!opcao?.chamarResumoBoleto}
                opcaoHandleChange={opcaoHandleChange}
              />
            );
          }
        )
      }
      
      <Box>
        <Divider />
      </Box>

      {
        !!acordos?.length &&
        (
          <>
            <Box display="flex" alignItems="flex-start">

              <Typography
                variant="h6"
                style={{ color: 'black', fontWeight: 'bold' }}
              >
                Acordos em dia
              </Typography>

              <HelperButton
                onMouseOver={
                  () => {
                    setHelperId('acordos');
                    setShowHelper(true);
                  }
                }
                onMouseOut={() => setShowHelper(false)}
              >
                <span>?</span>
              </HelperButton>

              {
                showHelper && helperId === 'acordos' &&
                (
                  <HelperContainer>
                    <HelperText>Você pode ver seus acordos em dia além de cancelar um acordo(quando permitido)já efetivado.</HelperText>
                  </HelperContainer>
                )
              }

            </Box>

            {
              acordos?.map(
                (item, index) => (
                  <DividaAcordoItem
                    key={index}
                    item={item}
                    itemDivida={item}
                    permiteBaixarBoleto={item?.permiteBaixarBoleto ?? true}
                    possuiParametrosBoleto={item?.possuiParametrosBoleto}
                    onClickRegularizar={() => onClickRegularizar(item)}
                  />
                )
              )
            }
          </>
        )
      }
    </>
  )
}
